import { render, staticRenderFns } from "./landing-nav-item.vue?vue&type=template&id=1d65ee95"
import script from "./landing-nav-item.vue?vue&type=script&lang=js"
export * from "./landing-nav-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports